/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Nograceperiod4Inputs */

const en_settings_reportingapikeys_nograceperiod4 = /** @type {(inputs: Settings_Reportingapikeys_Nograceperiod4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotation and deactivation take effect immediately. There is no overlap window between old and new keys.`)
};

/**
* | output |
* | --- |
* | "Rotation and deactivation take effect immediately. There is no overlap window between old and new keys." |
*
* @param {Settings_Reportingapikeys_Nograceperiod4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_nograceperiod4 = /** @type {((inputs?: Settings_Reportingapikeys_Nograceperiod4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Nograceperiod4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_nograceperiod4(inputs)
});
export { settings_reportingapikeys_nograceperiod4 as "settings_reportingApiKeys_noGracePeriod" }